import React from 'react';

import StepsPrivacy from '../stepsPrivacy/stepsPrivacy.js';
import PrivacyLogin from '../privacyLogin/PrivacyLogin.js';
import PrivacyTransfer from '../privacyTransfer/PrivacyTransfer.js';
import PrivacyAddressBook from '../privacyAddressBook/PrivacyAddressBook.js';
import PrivacyDeposit from '../privacyDeposit/PrivacyDeposit.js';
import PrivacyWithdraw from '../privacyWithdraw/PrivacyWithdraw.js';
import PrivacyAccount from '../privacyAccount/PrivacyAccount.js';

import { Modal } from 'rsuite';

import './Privacy.css';

import ethImg from '../../assets/ethereum.png';

function useOutsideAlerter(ref, setShow) {
    React.useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShow(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, setShow]);
}

function Privacy(props) {
    const assets = ['STRL','GUSDT','GDAI'];
    const [show, setShow] = React.useState(false);
    const [logged, setLogged] = React.useState(false);
    const [asset, setAsset] = React.useState(assets[0]);
    const [step, setStep] = React.useState(1);
    const [regState, setRegState] = React.useState(0);
    const [secret, setSecret] = React.useState("");
    const backdrop = true;

    const change = () => {
        setShow(!show);
    }

    //const findAssetName = (asset) => {
    //    for (let i = 0; i < assets.length; i++) {
    //        if (assets[i][0] === asset) {
    //            return assets[i][1];
    //        }
    //    }
    //}

    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, setShow);


    return (
        <React.Fragment>
	    <div onClick={() => change()} className="ghost-header-button">Privacy</div>
	    <Modal onHide={change} show={show} backdrop={backdrop}>
                <div ref={wrapperRef} className="ghost-privacy-container">
	            
                    <div className="ghost-privacy-main">
	                <div className="ghost-privacy-main-header">
	                    <div onClick={() => setAsset(assets[0])} className={asset === assets[0] ? "ghost-privacy-main-header-asset-active" : "ghost-privacy-main-header-asset"}>
	                        <img src={ethImg} alt="ethereum"></img>
	                        <span>{assets[0]}</span>
	                    </div>
	                    <div onClick={() => setAsset(assets[1])} className={asset === assets[1] ? "ghost-privacy-main-header-asset-active" : "ghost-privacy-main-header-asset"} >
	                        <img src={ethImg} alt="ethereum"></img>
	                        <span>{assets[1]}</span>
	                    </div>
	                    <div onClick={() => setAsset(assets[2])} className={asset === assets[2] ? "ghost-privacy-main-header-asset-active" : "ghost-privacy-main-header-asset"} >
	                        <img src={ethImg} alt="ethereum"></img>
	                        <span>{assets[2]}</span>
	                    </div>
	                </div>
	    	
	    		{!logged ?
	    		    <PrivacyLogin setStep={setStep} asset={asset} secret={secret} setSecret={setSecret} setLogged={setLogged} regState={regState} setRegState={setRegState} />
			   :
                           step === 2 ?
			       <PrivacyAddressBook asset={asset} /> 
			       :
			       step === 3 ?
		               <PrivacyTransfer asset={asset} />
			       :
			       step === 4 ?
			       <PrivacyDeposit asset={asset} />
			       :
			       step === 5 ?
			       <PrivacyWithdraw asset={asset} />
			       :
			       <PrivacyAccount asset={asset} />
			}
	            </div>

	            <StepsPrivacy step={step} setStep={setStep} logged={logged} setLogged={setLogged} />

                </div>
	    </Modal>
        </React.Fragment>
    )
}

export default Privacy;
